// Shared because the server sizes its fetch from this and the client slices the render by it.
export const HOME_BLOCK_ITEMS_PER_ROW = 7;
